import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';



@Injectable({
  providedIn: 'root'
})
export class FileUploaderService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private authSevice: AuthService,
  ) { }

  authToken = localStorage.getItem("auth");
  token = this.authSevice.getTokenData();

  httpAttachmentOptions = {
    withCredentials: true,
    headers: new HttpHeaders({ 'responseType': 'blob','auth': `${this.authToken}` }),
  };

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json','auth': `${this.authToken}` }),
    withCredentials: true,
  };



  uploadImageServer(uplodedFile,callback) {
    var err;
    const imageForm = new FormData();
    imageForm.append('file', uplodedFile,uplodedFile.fieldName);

    //Check that image is less than 2mb
    console.log(uplodedFile.size > 2000000)
    if(uplodedFile.size < 2000000){


    if(uplodedFile.type == "image/jpeg" || uplodedFile.type == "image/png" || uplodedFile.type == "image/jpg"){
     

    this.http.post(environment.EMPLOYER_SUBGROUP_IMAGE,imageForm, this.httpAttachmentOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var file = res.message;

          callback(err,file);


        } else { 
          alert('Tiedostotyyppiä ei tueta');
          callback(err,false)
          return;
          //loginError = true;
        }
      }, (err: any) => {
  
        console.log("Error while login :: ", err);
      }
    )
    }
    else{
      alert('Tiedostotyyppiä ei tueta');
      callback(err, false);
      return;
    }
  }
  else{
    alert('Tiedosto on liian suuri');
    callback(err, false);
    return;
  }
  
  }

  uploadBannerImg(uplodedFile,folder,callback) {
    var err;
    const imageForm = new FormData();
    imageForm.append('file', uplodedFile,uplodedFile.fieldName);

    //Check that image is less than 2mb
    console.log(uplodedFile.size > 2000000)
    if(uplodedFile.size < 2000000){


    if(uplodedFile.type == "image/jpeg" || uplodedFile.type == "image/png" || uplodedFile.type == "image/webp"){
     

    this.http.post(environment.ADMIN_UPLOAD_BANNER_IMG + '/' + folder,imageForm, this.httpAttachmentOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var file = res.message;

          callback(err,file);


        } else { 
          alert('Tiedostotyyppiä ei tueta');
          callback(err,false)
          return;
          //loginError = true;
        }
      }, (err: any) => {
  
        console.log("Error while login :: ", err);
      }
    )
    }
    else{
      alert('Tiedostotyyppiä ei tueta');
      callback(err, false);
      return;
    }
  }
  else{
    alert('Tiedosto on liian suuri');
    callback(err, false);
    return;
  }
  
  }


  uploadProfilePicture(uplodedFile,callback) {
    var err;
    const imageForm = new FormData();
    imageForm.append('file', uplodedFile,uplodedFile.fieldName);

    if(uplodedFile.size < 2000000){


    if(uplodedFile.type == "image/jpeg" || uplodedFile.type == "image/png"){
     

    this.http.post(environment.EMPLOYER_UPLOAD_PROFILE_PIC+ '/',imageForm, this.httpAttachmentOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          var file = res.message;

          callback(err,file);


        } else { 
          alert('Tiedostotyyppiä ei tueta');
          callback(err,false)
          return;
          //loginError = true;
        }
      }, (err: any) => {
  
        console.log("Error while login :: ", err);
      }
    )
    }
    else{
      alert('Tiedostotyyppiä ei tueta');
      callback(err, false);
      return;
    }
  }
  else{
    alert('Tiedosto on liian suuri');
    callback(err, false);
    return;
  }
  
  }

  




  deleteFile(file,callback){
    var req = {
      attachment:file,
    }
    var err;
    this.http.post(environment.EMPLOYER_DELETE_FILE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200) {
          callback(err,true)
        }
        else{
          callback(err,false);
        }
      }, (err: any) => {
        
        console.log("Error while login :: ", err);
      }
    )
  }








  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    console.log('2: ',binary.length);
    for (var i = 0; i < binary.length; i++) {
       array.push(binary.charCodeAt(i));
    }
   return new Blob([new Uint8Array(array)], {
   type: 'application/pdf',
   });
 }
}
